import featureToggle from '@helpers/feature_toggle'
import { getFullRoute } from '@helpers/routes'

import { COPYRIGHT_TM } from './constants'

export const getCopyrightText = () => {
  const copyrightSymbol = String.fromCharCode(COPYRIGHT_TM)
  const currentYear = new Date().getFullYear()

  return `${copyrightSymbol} ${currentYear} BeansiD`
}

export const getAccessibilityLink = (country) => {
  if (!featureToggle.isEnabled('accessibility_page')) return []

  return [
    {
      url: getFullRoute('accessibility', { country }),
      text: 'Accessibility'
    }
  ]
}

export const getFooterLinks = (country) => [
  {
    url: 'https://accounts.studentbeans.com/uk/info/privacy',
    text: 'Privacy Policy'
  },
  {
    url: 'https://accounts.studentbeans.com/uk/info/terms',
    text: 'Terms & Conditions'
  },
  {
    url: 'https://www.studentbeans.com/',
    text: 'Student Discounts'
  },
  {
    url: 'https://www.studentbeans.com/graduate-discount',
    text: 'Graduate Discounts'
  },
  {
    url: 'https://partner.studentbeans.com/brand-solutions/beans-id/',
    text: 'BeansiD For Business'
  },
  ...getAccessibilityLink(country)
]
